import { fetcher } from '@commenda/utils';
import { TEMPLATES_URL } from './helpers';

/** Idempotent: archiving an already-archived template returns 200. */
export const archiveDocumentAssemblerTemplate = async (
  templateId: string
): Promise<Response> => {
  const res = await fetcher(`${TEMPLATES_URL}/${templateId}/archive`, {
    method: 'POST',
    body: {},
  });
  return res;
};
